const {
	getTestOrgPagination,
	putTopic,
	deleteTopic,
	getStatisticReport,
} = require("../../utils/apiFunctions");

//edit topic
const editTopic = async (vueObj) => {
	vueObj.$v.$touch();
	if (!vueObj.$v.$invalid) {
		const res = await putTopic(vueObj.clone);
		if (res.status == 200) {
			vueObj.$emit("topicEdit", vueObj.showindex, vueObj.clone);
			vueObj.$bvModal.hide("topicConfg");
			vueObj.selTopic = "";
			vueObj.$nextTick(() => {
				vueObj.successToast("Topic updated successfully!");
				vueObj.$v.$reset();
			});
			vueObj.$emit("card-option", vueObj.topicDetails.topicID, false);
			vueObj.$emit("resetPagination", vueObj.showindex);
		} else if (res.status == 409) {
			vueObj.errorToast("Topic name already exists in active topics!");
			vueObj.$bvModal.hide("design-modal");
		} else {
			vueObj.$bvModal.hide("design-modal");
			vueObj.errorToast(`${res.data.data.Details}`);
			vueObj.$emit("card-option", vueObj.topicDetails.topicID, false);
			vueObj.$nextTick(() => {
				vueObj.$v.$reset();
			});
		}
	}
};

//delete topic
const deleteTopicData = async (vueObj) => {
	const res = await deleteTopic(vueObj.topicDetails);
	if (res.status == 200) {
		vueObj.$emit("resetPagination", vueObj.showindex);
		vueObj.$emit("lengthofTotalTopicsWhenDeletedUpdate");
		getStatisticReports(vueObj);
		vueObj.$nextTick(() => {
			vueObj.successToast("Topic deleted successfully!");
		});
	} else if (res.status === 409) {
		vueObj.errorToast("Topic is tagged to a job and cannot be deleted.");
	} else {
		vueObj.errorToast("Something went  wrong!");
	}
	vueObj.$bvModal.hide("deleteTopicModal");
};

//activate topic
const editTopicModal = async (vueObj) => {
	vueObj.clone.active = true;
	vueObj.$v.$touch();
	if (!vueObj.$v.$invalid) {
		vueObj.clone["testIDs"] = vueObj.allTestIds;
		const res = await putTopic(vueObj.clone);
		if (res.status == 200) {
			vueObj.$bvModal.hide("design-modal");
			vueObj.$bvModal.hide("topicConfg");
			vueObj.selTopic = "";
			vueObj.$emit("lengthofTotalTopicsWhenDeletedUpdate");
			getStatisticReports(vueObj);
			vueObj.$nextTick(() => {
				//payload sendddddd
				vueObj.successToast("Topic activated successfully!");
			});
			vueObj.$emit("resetPagination", vueObj.showindex);
		} else if (res.status == 409) {
			vueObj.$bvModal.hide("design-modal");
			vueObj.errorToast(`${res.data.data.Details}`);
		} else {
			vueObj.errorToast("Something went wrong!");
		}
	}
};

//get tests to activate
const getActivateTests = async (vueObj) => {
	vueObj.$v.$touch();
	if (!vueObj.$v.$invalid) {
		vueObj.LoaderStatus = true;
		let payload = {
			topicID: vueObj.topicDetails.topicID,
			sortBy: vueObj.sortColumn,
			order: vueObj.sortorder,
			type: 2,
			page: vueObj.page,
			count: vueObj.count,
		};
		const res = await getTestOrgPagination(payload);
		vueObj.actualres = res.data.data;
		vueObj.totalTestArr = vueObj.actualres.testIDs;
		vueObj.LoaderStatus = false;
		if (vueObj.actualres.total === 0) {
			vueObj.theTopicName = "No Topics Created";
		} else {
			vueObj.theTopicName = vueObj.actualres.topicName;
		}
		vueObj.totalTestCount = vueObj.actualres.total;
		for (let i of vueObj.totalTestArr) {
			i.view = null;
		}
		vueObj.design = true;
	}
};

const getStatisticReports = async (vueObj) => {
	let arr = [
		"topics",
		"tests",
		"autoGen",
		"candidateTests",
		"questionBank",
		"groups",
		"mostActiveTopic",
		"mostActiveTest",
		"mostActiveAutoGenTest",
	];
	let value = {};
	for (let i of arr) {
		getStatisticReport(i)
			.then((res) => {
				if (res.status == 200) {
					let showstatisticrecord = res.data.data;
					value = { ...value, ...showstatisticrecord };
					if (Object.keys(value).length == 16) {
						vueObj.starCandidates = value;
						vueObj.$store.commit("topicVUEX/savegetStatisticReport", value);
					}
				}
			})
			.catch((err) => {
				throw err;
			});
	}
};

module.exports = {
	editTopic,
	deleteTopicData,
	editTopicModal,
	getActivateTests,
	getStatisticReports,
};
